// Based on Gtag.js implementation
// https://developers.google.com/analytics/devguides/collection/gtagjs/

const gaTagTracking = (data: Record<string, any>): void => {
  if (typeof window === 'undefined') {
    return
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.dataLayer = window.dataLayer || []

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.dataLayer.push(data)
}

export default gaTagTracking
